module.exports = __webpack_public_path__ + "static/media/Cancel.42bbd077.svg";